function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFEFA8;}\n\t.st1{fill:#FCBE5F;}\n\t.st2{fill:#15A0A3;}\n\t.st3{fill:#F3806E;}\n\t.st4{fill:#4191CE;}\n\t.st5{fill:#62C7D4;}\n\t.st6{fill:#1877B6;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#11B9B8;}\n\t.st9{display:none;}\n\t.st10{display:inline;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "color_base"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1971.3,781.4 1971.3,784.3 1926.5,790.5 1926.5,786.4 1962.6,782.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1971.3,740.1 1971.3,781.4 1962.6,782.3 1962.6,740.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1962.6,740.2 1926.5,740.9 1926.5,734.2 1926.5,734.1 1971.3,734.1 1971.3,740.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1962.6,670.7 1971.3,671.5 1971.3,676.9 1926.5,673.5 1926.5,667.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1971.3,618.9 1971.3,671.5 1962.6,670.7 1962.6,617.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1962.6,617.6 1926.5,612.2 1926.5,605.9 1971.3,613.3 1971.3,618.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1971.2,490.4 1971.2,534.2 1957.7,530.9 1957.7,486.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1953.4,425.5 1971.2,431.6 1971.2,438.3 1916.7,420 1916.7,413.2 1939.3,420.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1971.2,383.7 1971.2,431.6 1953.4,425.5 1953.4,377.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1962.6,740.2 1962.6,782.3 1926.5,786.4 1926.5,740.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1962.6,617.6 1962.6,670.7 1926.5,667.3 1926.5,612.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1957.7,486.8 1957.7,530.9 1953.7,530 1953.7,529.9 1953.7,485.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1953.7,485.7 1953.7,529.9 1953.7,530 1936.9,525.9 1936.9,481.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1953.4,322.5 1953.4,322.6 1953.4,328.1 1939.3,322 1939.3,316.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1953.4,377.2 1953.4,425.5 1939.3,420.8 1939.3,420.8 1939.3,372.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1939.3,420.8 1939.3,420.8 1916.7,413.2 1916.7,363.9 1939.3,372.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1953.4,372.5 1939.3,367.3 1916.7,358.9 1916.7,363.9 1939.3,372.1 1953.4,377.2 1971.2,383.7  1971.2,379.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1936.9,481.3 1936.9,525.9 1932.2,524.8 1932.2,480  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1932.2,480 1932.2,524.8 1916.7,521.1 1916.7,475.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1926.5,581.6 1926.5,588.1 1893.3,582.5 1893.3,575.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1917,200.2 1917,206.4 1916.7,206.3 1916.7,200.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1917,206.4 1917,227 1916.7,226.9 1916.7,206.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1917,227 1917,244.6 1916.7,244.4 1916.7,226.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1917,244.6 1916.9,265.9 1916.7,265.8 1916.7,244.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1916.9,265.9 1916.9,274 1916.7,273.9 1916.7,265.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1916.7,549.9 1916.7,561.8 1902.6,558.9 1902.6,546.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1916.7,475.9 1916.7,521.1 1902.6,517.7 1902.6,472.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1916.7,420 1916.7,465.6 1902.6,461.8 1902.6,415.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1916.7,413.2 1916.7,420 1902.6,415.2 1902.6,408.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1916.7,363.9 1916.7,413.2 1902.6,408.4 1902.6,358.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1916.7,358.9 1916.7,363.9 1902.6,358.8 1902.6,353.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1902.6,332.2 1902.6,347.8 1902.6,353.7 1916.7,358.9 1916.7,353.1 1916.7,337.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1916.7,306.7 1916.7,312.3 1902.6,306.2 1902.6,300.6 1916.7,306.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1916.7,273.9 1916.7,306.7 1916.7,306.7 1902.6,300.6 1902.6,267.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1916.7,226.9 1916.7,244.4 1902.6,237.7 1902.6,219.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1957.7,530.9 1953.7,530 1936.9,525.9 1932.2,524.8 1916.7,521.1 1902.6,517.7 1887.4,514  1881.7,512.6 1865.2,508.6 1859.4,507.3 1842.6,503.2 1842.6,510 1902.6,524.3 1916.7,527.6 1971.2,540.6 1971.2,534.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1902.6,472.1 1902.6,517.7 1887.4,514 1887.4,468.1 1887.4,468  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1916.7,470.3 1902.6,466.5 1842.6,450.4 1842.6,456.1 1859.5,460.6 1865.2,462.1 1881.8,466.5  1887.4,468 1902.6,472.1 1916.7,475.9 1932.2,480 1936.9,481.3 1953.7,485.7 1957.7,486.8 1971.2,490.4 1971.2,484.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1916.7,420 1916.7,465.6 1902.6,461.8 1902.6,415.2 1842.6,395.1 1842.6,445.6 1842.6,450.4  1902.6,466.5 1916.7,470.3 1971.2,484.9 1971.2,480.3 1971.2,438.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1881.3,401.2 1902.6,408.4 1902.6,415.2 1842.6,395.1 1842.6,388.2 1867.3,396.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1902.6,358.8 1902.6,408.4 1881.3,401.2 1881.3,351.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1902.6,267.3 1902.6,300.6 1881.3,291.4 1881.3,257.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1853.6,794.6 1893.3,790.1 1893.3,795.1 1777.2,811.2 1777.2,803.1 1818.6,798.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1893.3,741.4 1893.3,790.1 1853.6,794.6 1853.6,742.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1818.6,742.7 1777.2,743.4 1777.2,733.8 1893.3,734 1893.3,734.1 1893.3,741.4 1853.6,742.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1853.6,660.4 1893.3,664.1 1893.3,670.9 1893.3,670.9 1777,662 1777,661.6 1777,653.1 1818.3,657  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1893.3,607.1 1893.3,664.1 1853.6,660.4 1853.6,601.4 1853.6,601.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1893.3,600.5 1893.3,607.1 1853.6,601.2 1818.4,595.8 1777,589.6 1777,581.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1887.4,468 1887.4,468.1 1887.4,514 1881.7,512.6 1881.7,466.6 1881.8,466.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1881.8,466.5 1881.7,466.6 1881.7,512.6 1865.2,508.6 1865.2,462.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1881.3,351.1 1881.3,401.2 1867.3,396.5 1867.3,346  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1881.3,291.4 1881.3,297 1867.3,291 1867.3,285.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1881.3,257.5 1881.3,291.4 1867.3,285.2 1867.3,250.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1881.3,209.5 1881.3,227.6 1867.3,220.9 1867.3,202.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1867.3,346 1867.3,396.5 1842.6,388.2 1842.6,337  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1881.3,345.8 1867.3,340.6 1842.6,331.4 1842.6,337 1867.3,346 1881.3,351.1 1902.6,358.8  1902.6,353.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1867.3,250.9 1867.3,285.2 1842.6,274.5 1842.6,239.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1865.2,462.1 1865.2,508.6 1859.4,507.3 1859.4,460.8 1859.5,460.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1859.5,460.6 1859.4,460.8 1859.4,507.3 1842.6,503.2 1842.6,456.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1818.4,595.8 1853.6,601.2 1853.6,601.4 1853.6,660.4 1818.3,657 1818.3,596  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1853.6,742.1 1853.6,794.6 1818.6,798.5 1818.6,742.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1842.8,693.8 1842.8,704.6 1828.7,704.2 1828.7,693.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1828.5,506.6 1828.5,511.6 1828.5,564.3 1828.5,571.5 1828.5,581.2 1842.6,583.5 1842.6,583.2  1842.6,573.9 1842.6,566.8 1842.6,514.9 1842.6,510  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1842.6,503.2 1842.6,510 1828.5,506.6 1828.5,499.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1842.6,456.1 1842.6,503.2 1828.5,499.8 1828.5,452.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1842.6,450.4 1842.6,456.1 1828.5,452.3 1828.5,446.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1828.5,390.4 1828.5,441.7 1828.5,446.6 1842.6,450.4 1842.6,445.6 1842.6,395.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1842.6,388.2 1842.6,395.1 1828.5,390.4 1828.5,383.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1842.6,337 1842.6,388.2 1828.5,383.4 1828.5,331.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1842.6,331.4 1842.6,337 1828.5,331.9 1828.5,326.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1828.5,302.3 1828.5,319.8 1828.5,326.2 1842.6,331.4 1842.6,325.1 1842.6,308  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1842.6,274.5 1842.6,280.4 1828.5,274.3 1828.5,268.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1842.6,239.5 1842.6,274.5 1828.5,268.4 1828.5,233  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1842.6,190.5 1842.6,209.2 1828.5,202.5 1828.5,183.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1828.5,452.3 1828.5,499.8 1811.2,495.6 1811.2,447.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1804.6,375.4 1828.5,383.4 1828.5,390.4 1765.4,369.2 1765.4,362.1 1790.5,370.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1828.5,331.9 1828.5,383.4 1804.6,375.4 1804.6,323.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1828.5,233 1828.5,268.4 1804.6,258 1804.6,221.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1818.6,742.7 1818.6,798.5 1777.2,803.1 1777.2,743.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1818.4,595.8 1818.3,596 1818.3,657 1777,653.1 1777,589.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1811.2,447.7 1811.2,495.6 1804.5,494 1804.5,493.9 1804.5,445.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1804.6,323.2 1804.6,375.4 1790.5,370.6 1790.5,318.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1804.6,258 1804.6,264 1790.5,257.9 1790.5,251.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1804.6,221.9 1804.6,258 1790.5,251.8 1790.5,215.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1804.6,171.8 1804.6,191.1 1790.5,184.4 1790.5,164.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1804.5,445.9 1804.5,493.9 1804.5,494 1787,489.8 1787,489.6 1787,441.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1790.5,318.1 1790.5,370.6 1765.4,362.1 1765.4,309  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1804.6,317.3 1790.5,312.1 1765.4,302.8 1765.4,309 1790.5,318.1 1804.6,323.2 1828.5,331.9  1828.5,326.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1790.5,215.3 1790.5,251.8 1765.4,240.9 1765.4,203.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1787,441.2 1787,489.6 1787,489.8 1781.1,488.4 1781.2,488.1 1781.2,439.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1781.2,439.7 1781.2,488.1 1781.1,488.4 1765.4,484.6 1765.4,435.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1740.6,548.8 1777,555.2 1777,555.4 1777,562.7 1740.6,556.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1765.4,517.9 1765.4,530.9 1751.3,528.1 1751.3,515  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1765.4,435.5 1765.4,484.6 1751.3,481.2 1751.3,431.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1765.4,369.2 1765.4,424.7 1751.3,420.9 1751.3,364.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1765.4,362.1 1765.4,369.2 1751.3,364.4 1751.3,357.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1765.4,309 1765.4,362.1 1751.3,357.3 1751.3,303.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1765.4,302.8 1765.4,309 1751.3,303.8 1751.2,297.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1751.2,271.1 1751.2,290.6 1751.2,297.5 1765.4,302.8 1765.4,295.9 1765.4,276.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1765.4,240.9 1765.4,247.1 1751.2,241 1751.2,234.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1765.4,203.7 1765.4,240.9 1751.2,234.7 1751.4,234.5 1751.7,234.6 1751.6,197.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1902.6,259.3 1881.3,249.4 1867.3,242.9 1842.6,231.5 1828.5,225 1804.6,213.9 1790.5,207.4  1765.4,195.8 1751.6,189.4 1751.6,197.3 1765.4,203.7 1790.5,215.3 1804.6,221.9 1828.5,233 1842.6,239.5 1867.3,250.9  1881.3,257.5 1902.6,267.3 1916.7,273.9 1916.7,265.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1765.4,152.6 1765.4,172.4 1751.6,165.8 1751.5,145.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1916.7,226.9v-20.6l-14.1-7.1l-21.3-10.8l-14.1-7.1l-24.6-12.4l-14.1-7.1l-23.9-12.1l-14.1-7.1l-25.1-12.7 l-13.9-7.1l0,23l13.9,6.8v19.9l-13.8-6.6l0,23.5l13.8,6.4l25.1,11.6l14.1,6.5l23.9,11.1l14.1,6.5l24.6,11.4l14.1,6.5l21.3,9.9 l14.1,6.5v-21.4l-14.1-6.7v-17.8L1916.7,226.9z M1790.5,184.4v-19.5l14.1,6.9v19.3L1790.5,184.4z M1828.5,202.5v-18.9l14.1,6.9 v18.7L1828.5,202.5z M1881.3,227.6l-14.1-6.7v-18.4l14.1,6.9V227.6z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1902.6,192.6 1881.5,181.3 1867.7,173.9 1842.9,160.6 1829.1,153.3 1804.9,140.3 1791.1,133  1765.4,119.2 1751.5,111.7 1751.5,122.7 1765.4,129.8 1790.5,142.5 1804.6,149.6 1828.5,161.7 1842.6,168.8 1867.3,181.3  1881.3,188.4 1902.6,199.1 1916.7,206.3 1916.7,200.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1751.6,165.8 1751.6,189.4 1751.6,197.3 1751.7,234.6 1751.4,234.5 1728.4,224.5 1713.6,218.1  1684.5,205.4 1670.1,199.2 1669.9,199.2 1329.3,285.5 1329.3,285.5 1329.3,286.3 1329.2,286.3 1315.2,282.1 1315.3,282  1315.3,234 1475.6,189 1551.2,167.9 1751.5,111.7 1751.5,122.7 1751.5,145.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1811.2,495.6 1804.5,494 1787,489.8 1781.1,488.4 1765.4,484.6 1751.3,481.2 1735.1,477.3  1728.2,475.6 1708.5,470.9 1701.5,469.2 1684.3,465.1 1684.3,472.3 1751.3,488.3 1765.4,491.6 1828.5,506.6 1828.5,499.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1751.3,431.7 1751.3,481.2 1735.1,477.3 1735.1,427.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1765.4,429.7 1751.3,425.9 1684.3,407.9 1684.3,413.8 1701.5,418.4 1708.5,420.3 1728.2,425.5  1735.1,427.4 1751.3,431.7 1765.4,435.5 1781.2,439.7 1787,441.2 1804.5,445.9 1811.2,447.7 1828.5,452.3 1828.5,446.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1765.4,369.2 1765.4,424.7 1751.3,420.9 1751.3,364.4 1684.3,341.9 1684.3,402.7 1684.3,407.9  1751.3,425.9 1765.4,429.7 1828.5,446.6 1828.5,441.7 1828.5,390.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1751.3,357.3 1751.3,364.4 1684.3,341.9 1684.3,334.8 1713.5,344.6 1727.9,349.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1751.3,303.8 1751.3,357.3 1727.9,349.5 1727.9,349.4 1727.9,295.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1694.4,812.4 1740.6,807.2 1740.6,816.2 1607,834.7 1607,822.2 1658.7,816.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1740.6,744 1740.6,807.2 1694.4,812.4 1694.4,744.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1658.7,745.5 1607,746.3 1607,734 1607,733.6 1740.6,733.8 1740.6,733.8 1740.6,744 1694.4,744.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1694.4,645.3 1740.6,649.7 1740.6,659.1 1740.6,659.2 1607,649 1607,637 1658.6,641.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1740.6,584 1740.6,649.7 1694.4,645.3 1694.4,577.3 1694.5,577.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1740.6,575.3 1740.6,584 1694.5,577.1 1658.6,571.7 1607,563.9 1607,553.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1735.1,427.4 1735.1,477.3 1728.2,475.6 1728.2,425.7 1728.2,425.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1728,224.3 1727.9,225.2 1727.9,230.9 1713.6,224.7 1713.6,218.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1708.5,420.3 1728.2,425.5 1728.2,425.7 1728.2,475.6 1708.5,470.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1727.9,295.4 1727.9,349.4 1727.9,349.5 1713.5,344.6 1713.6,344.5 1713.6,290.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1713.6,290.2 1713.6,344.5 1713.5,344.6 1684.3,334.8 1684.3,279.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1751.2,297.5 1727.9,288.8 1713.6,283.5 1684.3,272.6 1684.3,279.6 1713.6,290.2 1727.9,295.4  1751.3,303.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1708.5,420.3 1708.5,470.9 1701.5,469.2 1701.5,418.4 1701.5,418.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1701.5,418.4 1701.5,418.4 1701.5,469.2 1684.3,465.1 1684.3,413.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1694.5,577.1 1694.4,577.3 1694.4,645.3 1658.6,641.9 1658.6,641.7 1658.6,571.7 1658.6,571.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1694.4,744.8 1694.4,812.4 1658.7,816.4 1658.7,745.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1684.5,686.6 1684.5,700.3 1670.1,699.8 1670.1,685.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1684.5,205.4 1684.3,205.7 1684.3,212.1 1670.6,206.2 1670.1,206.2 1670.1,199.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1669.9,468.9 1669.9,474.5 1669.9,536.3 1669.9,544.6 1669.9,555.4 1684.3,557.7 1684.3,547  1684.3,538.9 1684.3,477.9 1684.3,472.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1684.3,465.1 1684.3,472.3 1669.9,468.9 1669.9,461.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1684.3,413.8 1684.3,465.1 1669.9,461.6 1669.9,410  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1684.3,407.9 1684.3,413.8 1669.9,410 1669.9,404.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1669.9,337.1 1669.9,398.8 1669.9,404.1 1684.3,407.9 1684.3,402.7 1684.3,341.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1684.3,334.8 1684.3,341.9 1669.9,337.1 1669.9,330.3 1670.1,330.3 1670.1,330  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1684.3,279.6 1684.3,334.8 1670.1,330 1670.1,274.6 1670.6,274.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1684.3,272.6 1684.3,279.6 1670.6,274.6 1670.1,274.6 1670.1,267.6 1670.6,267.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1670.6,238.5 1670.1,238.5 1670.1,260.2 1670.1,267.6 1670.6,267.6 1684.3,272.6 1684.3,265.3  1684.3,244  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1953.4,346.8 1953.4,352.7 1953.4,366.9 1939.3,361.6 1939.3,347 1939.3,341 1916.7,331.9  1902.6,326.2 1881.3,317.6 1881.3,323.6 1881.3,339.7 1867.3,334.4 1867.3,317.9 1867.3,311.9 1842.6,301.9 1828.5,296.2  1804.6,286.5 1804.6,292.6 1804.6,310.8 1790.5,305.4 1790.5,286.9 1790.5,280.8 1765.4,270.7 1751.2,264.9 1727.9,255.5  1727.9,261.7 1727.9,281.8 1713.6,276.4 1713.6,255.9 1713.6,249.7 1684.3,237.8 1670.3,232.1 1670.1,232.1 1670.1,238.5  1670.6,238.5 1684.3,244 1684.3,265.3 1684.3,272.6 1713.6,283.5 1727.9,288.8 1751.2,297.5 1751.2,290.6 1751.2,271.1  1765.4,276.8 1765.4,295.9 1765.4,302.8 1790.5,312.1 1804.6,317.3 1828.5,326.2 1828.5,319.8 1828.5,302.3 1842.6,308  1842.6,325.1 1842.6,331.4 1867.3,340.6 1881.3,345.8 1902.6,353.7 1902.6,347.8 1902.6,332.2 1916.7,337.9 1916.7,353.1  1916.7,358.9 1939.3,367.3 1953.4,372.5 1971.2,379.2 1971.2,373.7 1971.2,359.9 1971.2,354  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1953.4,322.5 1953.4,322.6 1953.4,328.1 1939.3,322 1939.3,316.4 1916.9,306.6 1916.7,306.7  1916.7,312.3 1902.6,306.2 1902.6,300.6 1881.3,291.4 1881.3,297 1867.3,291 1867.3,285.2 1842.6,274.5 1842.6,280.4  1828.5,274.3 1828.5,268.4 1804.6,258 1804.6,264 1790.5,257.9 1790.5,251.8 1765.4,240.9 1765.4,247.1 1751.2,241 1751.2,234.7  1751.4,234.5 1728,224.3 1727.9,225.2 1727.9,230.9 1713.6,224.7 1713.6,218.1 1684.5,205.4 1684.3,205.7 1684.3,212.1  1670.6,206.2 1670.1,206.2 1670.1,232.1 1670.3,232.1 1684.3,237.8 1713.6,249.7 1713.6,255.9 1713.6,276.4 1727.9,281.8  1727.9,261.7 1727.9,255.5 1751.2,264.9 1765.4,270.7 1790.5,280.8 1790.5,286.9 1790.5,305.4 1804.6,310.8 1804.6,292.6  1804.6,286.5 1828.5,296.2 1842.6,301.9 1867.3,311.9 1867.3,317.9 1867.3,334.4 1881.3,339.7 1881.3,323.6 1881.3,317.6  1902.6,326.2 1916.7,331.9 1939.3,341 1939.3,347 1939.3,361.6 1953.4,366.9 1953.4,352.7 1953.4,346.8 1971.2,354 1971.2,335.7  1971.2,330.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1670.1,330 1670.1,330.3 1669.9,330.3 1669.9,329.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1670.1,274.6 1670.1,330 1669.9,329.9 1669.9,199.2 1670.1,199.2 1670.1,206.2 1670.1,232.1  1670.1,238.5 1670.1,260.2 1670.1,267.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1669.9,410 1669.9,461.6 1649.6,456.7 1649.6,404.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1669.9,330.3 1669.9,337.1 1592.5,311.1 1592.5,303.8 1594.4,304.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1669.9,329.9 1669.9,330.3 1594.4,304.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1592.5,303.8 1577.2,298.6 1577.1,298.6 1372.3,343.9 1372.2,343.9 1372.2,343.6 1329.3,332.1  1329.3,286.3 1329.3,285.5 1329.3,285.5 1669.9,199.2 1669.9,329.9 1594.4,304.4 1592.5,303.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1658.7,745.5 1658.7,816.4 1607,822.2 1607,746.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1658.6,571.7 1658.6,641.7 1658.6,641.9 1607,637 1607,563.9 1658.6,571.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1649.6,404.5 1649.6,456.7 1641.5,454.8 1641.6,454.5 1641.6,402.5 1641.7,402.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1641.7,402.4 1641.6,402.5 1641.6,454.5 1641.5,454.8 1621.4,449.9 1621.4,397.1 1621.4,397  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1621.4,397 1621.4,397.1 1621.4,449.9 1613.2,447.9 1613.3,447.6 1613.3,394.9 1613.3,394.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1592.5,389.3 1613.3,394.9 1613.3,394.9 1613.3,447.6 1613.2,447.9 1592.5,442.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1607,525.2 1607,533.9 1577.2,528.8 1577.2,520  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1592.5,481.1 1592.5,494.9 1577.2,491.8 1577.2,477.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M1926.5,786.4v-45.5v-6.7v-0.1l44.8,0.1l0-57.2l-44.8-3.4v-6.2v-55.1v-6.2l44.8,7.4v-8.9v-8.7v-6.2l0-44.6 v-4.3l-54.5-13l-14.1-3.4l-60-14.3v4.9v51.9v7.1v9.4l-0.1,0.2l-14-2.3v-9.7v-7.2v-52.7v-4.9l-63.1-15l-14.1-3.4l-67-16v5.6v61 v8.1v10.7l-14.4-2.3v-10.9v-8.2v-61.8v-5.6l-77.5-18.4l-15.2-3.6v6v25l15.2,3.2v13.8l-15.2-3.2V520l29.7,5.3v8.6l-29.7-5v21v9.6 v74.8v12.5v2.1v84.7v13.3v78.7v13.3v45.4l394.1-80.9v-19l-44.8,6.2V786.4z M1916.7,549.9v11.9l-14.1-2.9v-12L1916.7,549.9z  M1765.4,517.9v13l-14.1-2.9V515L1765.4,517.9z M1740.6,733.8V744v63.2v9L1607,834.7v-12.5v-75.9V734v-0.4L1740.6,733.8 L1740.6,733.8z M1670.1,699.8v-14.3l14.5,1.1v13.7L1670.1,699.8z M1740.6,584v65.6v9.4v0.1L1607,649v-12v-73.2v-10.6l133.6,22 V584z M1740.6,548.8l36.5,6.4l0,0.2v7.3l-36.4-6.2V548.8z M1893.3,734.1v7.4v48.7v5l-116.2,16.1v-8.1v-59.7v-9.6L1893.3,734.1 L1893.3,734.1z M1828.7,704.2v-11.1l14.1,0.7v10.8L1828.7,704.2z M1893.3,607.1v57v6.8v0.1L1777,662l0-0.4v-8.5v-63.6v-8.3 l116.3,19.2V607.1z M1893.3,575.7l33.2,5.8v6.5l-33.2-5.6V575.7z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1649.6,456.7 1641.5,454.8 1621.4,449.9 1613.2,447.9 1592.5,442.9 1577.2,439.3 1577.2,439.9  1577.2,446.8 1592.5,450.4 1669.9,468.9 1669.9,461.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1592.5,389.3 1592.5,442.9 1577.2,439.3 1577.2,385.4 1577.8,385.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1592.5,383.3 1577.7,379.3 1577.2,379.3 1577.2,385.4 1577.8,385.4 1592.5,389.3 1613.3,394.9  1621.4,397 1641.7,402.4 1649.6,404.5 1669.9,410 1669.9,404.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1592.5,311.1 1592.5,377.9 1577.2,373.8 1577.2,379.3 1577.7,379.3 1592.5,383.3 1669.9,404.1  1669.9,398.8 1669.9,337.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "1592.5,311.1 1592.5,377.9 1577.2,373.8 1577.2,306  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1592.5,303.8 1592.5,311.1 1577.2,306 1577.2,298.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1592.5,303.8 1592.5,303.8 1577.2,298.7 1577.2,298.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1577.2,477.8 1577.2,491.8 1577.2,491.8 1577.1,477.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1577.2,373.8 1577.2,379.3 1577.2,385.4 1577.2,439.3 1577.2,439.9 1411.1,398.6 1372.2,389.3  1372.2,343.9 1372.3,343.9 1577.1,298.6 1577.2,298.7 1577.2,306  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1577.2,298.6 1577.2,298.7 1577.1,298.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1550.8,167 1551.2,167.9 1475.6,189 1475.6,133.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1315.3,234 1314.9,234.1 1314.9,234.2 1288.8,225.7 1288.8,196 1475.6,133.5 1475.6,189  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "1411.1,398.6 1372.2,389.3 1201.2,348.4 1201.1,348.5 1201.2,614 1409.8,633.6 1409.8,915.4  1577.2,884.2 1577.2,838.9 1577.2,825.5 1577.2,746.8 1577.2,733.5 1577.2,648.8 1577.2,646.7 1577.2,634.2 1577.2,559.4  1577.2,549.8 1577.2,528.8 1577.2,520 1577.2,491.8 1577.2,491.8 1577.1,477.8 1577.2,477.8 1577.2,452.8 1577.2,446.8  1577.2,439.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "1409.8,633.6 1409.8,915.4 1194.7,915.1 1320.5,915.1 1320.5,914.9 1334.4,914.9 1334.4,729.1  1240.4,729.1 1162.6,729.1 1068.2,729.1 1068.2,914.9 1082.1,914.9 1082.1,914.9 1038.2,914.9 991,914.8 991,633.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1409.8,633.6 991,633.1 1201.2,614  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "1329.3,332.1 1372.2,343.6 1372.2,343.9 1372.2,389.3 1201.2,348.4 1201.1,348.5 1201.1,297.9  1201.2,297.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "1329.3,286.3 1329.3,332.1 1201.2,297.9 1201.1,297.9 1201,248.4 1201.2,248.4 1315.2,282.1  1329.2,286.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "1320.5,914.9 1320.5,915.1 1194.7,915.1 1082.1,914.9 1082.1,914.9 1084.9,914.9 1162.6,914.9  1240.4,914.9 1318.2,914.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "1314.9,234.2 1314.9,234.1 1315.3,234 1315.3,282 1315.2,282.1 1201.2,248.4 1201,248.4 1201,197.3  1201.2,197.4 1288.8,225.7  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 1251.8,
  y: 796.5,
  className: "st6",
  width: 55.2,
  height: 99
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "1288.8,196 1288.8,225.7 1201.2,197.4 1201.2,162.9  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 1173.9,
  y: 796.5,
  className: "st6",
  width: 55.2,
  height: 99
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1201.2,162.9 1201.2,197.4 1201,197.3 1201,197.3 1110.5,226.6 1110.5,195.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1201.1,297.9 1201.1,348.5 1033.3,388.6 1033.3,343.1 1033.3,343.1 1033.2,342.9 1075,331.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1201,248.4 1201.1,297.9 1075,331.7 1075,331.6 1075,285.6 1075,285.6 1087,282  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1087.4,234.1 1110.5,226.6 1201,197.3 1201,197.3 1201,248.4 1087,282 1087,233.9 1087.3,234  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "1194.7,915.1 1082.1,915.1 1082.1,914.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "1240.4,763 1162.6,763 1084.9,763 1084.9,784.1 1162.6,784.1 1240.4,784.1 1318.2,784.1 1318.2,763  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 1096.1,
  y: 796.5,
  className: "st6",
  width: 55.2,
  height: 99
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1087,233.9 930.1,189.9 929,133.2 1110.5,195.8 1110.5,226.6 1087.4,234.1 1087.3,234  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "650.7,122.6 650.7,111.8 650.9,111.6 849.4,167.2 930.1,189.9 1087,233.9 1087,282 1075,285.6  1075,285.6 1074.9,285.6 732.2,199 717.8,205.3 688.6,218.1 673.9,224.5 650.9,234.6 650.9,197 650.9,189 650.8,165.6  650.8,145.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "825.5,297.2 825.1,298.4 809.7,303.6 732.2,329.7 732.2,206.1 732.2,199 1074.9,285.6 1075,285.6  1075,331.6 1075,331.7 1033.2,342.9 1033.3,343.1 1033.3,343.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "825.1,305.8 825.1,298.4 825.5,297.2 1033.3,343.1 1033.3,388.6 996,397.5 991,398.7 985.6,400  825.1,438.6 825.1,385.2 825.1,379.1 825.1,373.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "1201.1,348.5 1033.3,388.6 996,397.5 991,398.7 991,398.7 985.6,400 825.1,438.6 825.1,446.6  825.1,452.6 825,477.6 825,519.8 825,528.6 825,634 825,646.5 825,648.3 825,735.7 825,747.8 825,825.4 825,838.7 825,884.8  991,914.8 991,633.1 1201.2,614  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "991,398.7 991,398.7 985.6,400  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "929,133.2 930.1,189.9 849.4,167.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "825.1,305.8 825.1,373.6 809.7,377.7 809.7,310.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "825.1,298.4 825.1,305.8 809.7,310.9 809.7,303.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "825.1,385.2 825.1,438.6 825,438.6 825,439.3 824,439.3 809.7,442.8 809.7,389.1 824.4,385.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "825,519.8 825,528.6 795.2,533.7 795.2,525.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "825,477.7 825,491.6 809.7,494.7 809.7,480.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "824,439.3 809.7,442.8 789,447.7 780.8,449.7 760.6,454.6 752.5,456.5 732.2,461.4 732.2,468.7  809.7,450.2 825,446.6 825,439.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "809.7,389.1 809.7,442.8 789,447.7 788.9,447.4 788.9,394.8 788.8,394.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "824.4,379.1 809.7,383.1 732.2,403.9 732.2,409.8 752.5,404.4 760.4,402.2 780.8,396.8 788.8,394.7  809.7,389.1 824.4,385.2 825.1,385.2 825.1,379.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "809.7,377.7 809.7,310.9 732.2,336.9 732.2,398.7 732.2,403.9 809.7,383.1 824.4,379.1 825.1,379.1  825.1,373.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "809.7,303.6 809.7,310.9 732.2,336.9 732.2,329.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "809.7,303.6 732.2,329.8 732.2,329.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "707.8,812.2 743.5,816.2 795.2,822 795.2,834.5 661.6,816 661.6,807  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "795.2,747.3 795.2,822 743.5,816.2 743.5,746.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "707.8,745.8 661.6,745 661.6,735.9 795.2,735.8 795.2,747.3 743.5,746.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "707.8,645.1 743.6,641.7 795.2,636.8 795.2,648.8 661.6,659 661.6,658.9 661.6,649.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "795.2,563.7 795.2,636.8 743.6,641.7 743.5,641.6 743.5,571.5 743.5,571.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "795.2,553.1 795.2,563.7 743.5,571.5 707.7,576.9 661.6,583.9 661.6,575.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "788.9,447.4 789,447.7 780.8,449.7 780.8,396.9 780.8,396.8 788.8,394.7 788.9,394.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "780.8,396.9 780.8,449.7 760.6,454.6 760.5,454.3 760.5,402.3 760.4,402.2 780.8,396.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "760.5,454.3 760.6,454.6 752.5,456.5 752.5,404.4 760.4,402.2 760.5,402.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "752.5,404.4 752.5,456.5 732.2,461.4 732.2,409.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "743.5,641.6 743.6,641.7 707.8,645.1 707.8,577.1 707.7,576.9 743.5,571.5 743.5,571.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "743.5,746.4 743.5,816.2 707.8,812.2 707.8,745.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "717.9,472.1 717.9,477.7 717.9,538.7 717.9,546.8 717.9,557.5 732.2,555.2 732.2,544.4 732.2,536.1  732.2,474.3 732.2,468.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "732.2,461.4 732.2,468.7 717.9,472.1 717.9,464.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "732.2,409.8 732.2,461.4 717.9,464.9 717.9,413.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "732.2,403.9 732.2,409.8 717.9,413.6 717.9,407.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "717.9,341.8 717.9,402.6 717.9,407.7 732.2,403.9 732.2,398.7 732.2,336.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "732.2,329.8 732.2,336.9 717.9,341.8 717.9,334.6 732.1,329.8 732.1,329.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "732.2,329.7 732.2,329.8 732.1,329.8 732.1,329.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "732.2,206.1 732.2,329.7 732.1,329.8 732.2,274.4 732.2,267.3 732.2,260.1 732.2,238.3 732.2,232  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "732.2,199 732.2,206.1 731.5,206.1 717.9,211.9 717.9,205.5 717.8,205.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "731.5,238.3 717.9,243.9 717.9,265.1 717.9,272.4 731.5,267.3 732.2,267.3 732.2,260.1 732.2,238.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "732.2,267.3 732.2,274.4 731.5,274.4 717.9,279.4 717.9,272.4 731.5,267.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "732.2,274.4 732.1,329.8 717.9,334.6 717.9,279.4 731.5,274.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "732.1,685.3 732.1,699.6 717.6,700.1 717.6,686.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "717.9,413.6 717.9,464.9 700.7,469 700.7,418.3 700.7,418.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "717.9,334.6 717.9,341.8 650.9,364.3 650.9,357.2 674.3,349.3 688.7,344.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "717.9,279.4 717.9,334.6 688.7,344.5 688.6,344.3 688.6,290  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "717.9,272.4 717.9,279.4 688.6,290 688.6,283.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "707.8,745.8 707.8,812.2 661.6,807 661.6,745  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "707.8,577.1 707.8,645.1 661.6,649.5 661.6,583.9 707.7,576.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "700.7,418.3 700.7,469 693.7,470.7 693.7,420.1 700.7,418.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "693.7,420.1 693.7,470.7 674,475.4 674,425.5 673.9,425.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "688.6,344.3 688.7,344.5 674.3,349.3 674.2,349.3 674.2,295.2 688.6,290  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "688.6,283.3 688.6,290 674.2,295.2 674.2,288.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "688.6,218.1 688.6,224.6 674.2,230.8 674.2,225.1 673.9,224.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "674.3,349.3 650.9,357.2 650.9,303.7 674.2,295.2 674.2,349.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "674.2,288.6 674.2,295.2 650.9,303.7 650.9,297.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "674,425.5 674,475.4 667.1,477.1 667.1,427.2 673.9,425.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "667.1,427.2 667.1,477.1 650.8,481.1 650.9,431.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "661.6,548.6 661.6,556.4 625.2,562.6 625.2,555.2 625.1,555  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "650.9,197 650.9,234.6 636.8,240.7 636.8,203.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "650.9,234.6 650.9,240.8 636.8,246.9 636.8,240.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "636.8,276.6 636.8,295.8 636.8,302.6 650.9,297.3 650.9,290.4 650.9,270.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "650.9,297.3 650.9,303.7 636.8,308.8 636.8,302.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "650.9,303.7 650.9,357.2 636.8,362 636.8,308.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "650.9,357.2 650.9,364.3 636.8,369 636.8,362  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "650.9,364.3 650.9,420.7 636.8,424.5 636.8,369  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "650.9,514.8 650.9,527.9 636.8,530.7 636.8,517.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "650.9,431.5 650.8,481.1 636.8,484.4 636.8,435.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "650.8,145.5 650.8,165.6 650.8,165.6 636.8,172.2 636.8,152.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "700.7,469 693.7,470.7 674,475.4 667.1,477.1 650.8,481.1 636.8,484.4 621,488.2 615.2,489.6  597.7,493.8 591,495.5 573.6,499.6 573.6,506.5 636.8,491.4 650.8,488.1 717.9,472.1 717.9,464.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "636.8,435.3 636.8,484.4 621,488.2 620.9,487.9 620.9,439.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "650.9,425.7 636.8,429.5 573.6,446.5 573.6,452.2 591,447.5 597.6,445.7 615.1,441.1 620.9,439.5  636.8,435.3 650.9,431.5 667.1,427.2 673.9,425.4 693.7,420.1 700.7,418.2 717.9,413.6 717.9,407.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "650.9,364.3 650.9,420.7 636.8,424.5 636.8,369 573.6,390.2 573.6,441.6 573.6,446.5 636.8,429.5  650.9,425.7 717.9,407.7 717.9,402.6 717.9,341.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "611.7,370.4 636.8,362 636.8,369 573.6,390.2 573.6,383.3 597.6,375.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "636.8,308.8 636.8,362 611.7,370.4 611.7,317.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "636.8,302.6 636.8,308.8 611.7,317.9 611.7,311.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "636.8,203.5 636.8,240.7 611.7,251.6 611.7,215.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "583.8,656.8 625.2,652.9 625.2,661.4 625.2,661.8 508.8,670.8 508.8,670.7 508.8,663.9 548.6,660.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "625.2,589.4 625.2,652.9 583.8,656.8 583.8,595.8 583.8,595.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "625.2,581.1 625.2,589.4 583.8,595.6 548.5,601 508.8,607 508.8,600.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "548.6,794.4 583.5,798.3 625,802.9 625,811 508.8,794.9 508.8,789.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "625,744.4 625,802.9 583.5,798.3 583.5,743.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "548.6,743.1 508.8,742.4 508.8,736.2 625,736 625,744.4 583.5,743.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "620.9,487.9 621,488.2 615.2,489.6 615.1,489.4 615.1,441.1 620.9,439.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "615.1,489.4 615.2,489.6 597.7,493.8 597.6,493.7 597.6,445.7 615.1,441.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "611.7,317.9 611.7,370.4 597.6,375.2 597.6,323.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "611.7,311.9 611.7,317.9 597.6,323.1 597.6,317.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "611.7,251.6 611.7,257.7 597.6,263.8 597.6,257.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "611.7,215.2 611.7,251.6 597.6,257.8 597.6,221.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "611.7,164.7 611.7,184.2 597.6,190.9 597.6,171.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "597.6,493.7 597.7,493.8 591,495.5 591,447.5 597.6,445.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "597.6,323.1 597.6,375.2 573.6,383.3 573.6,331.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "597.6,317.1 597.6,323.1 573.6,331.7 573.6,326  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "597.6,221.7 597.6,257.8 573.6,268.2 573.6,232.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "591,447.5 591,495.5 573.6,499.6 573.6,452.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "583.8,595.8 583.8,656.8 548.6,660.1 548.6,601.2 548.5,601 583.8,595.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "583.5,743.7 583.5,798.3 548.6,794.4 548.6,743.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "559.5,509.8 559.5,514.7 559.5,566.6 559.5,573.7 559.5,583 559.6,583.3 573.6,581 573.6,571.3  573.6,564.1 573.6,511.4 573.6,506.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "573.6,499.6 573.6,506.5 559.5,509.8 559.5,503  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "573.6,452.2 573.6,499.6 559.5,503 559.5,455.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "573.6,446.5 573.6,452.2 559.5,455.9 559.5,450.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "559.5,394.9 559.5,445.4 559.5,450.2 573.6,446.5 573.6,441.6 573.6,390.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "573.6,383.3 573.6,390.2 559.5,394.9 559.5,388  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "573.6,331.7 573.6,383.3 559.5,388 559.5,336.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "573.6,326 573.6,331.7 559.5,336.8 559.5,331.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "559.5,307.8 559.5,324.9 559.5,331.2 573.6,326 573.6,319.6 573.6,302.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "573.6,268.2 573.6,274.1 559.5,280.2 559.5,274.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "573.6,232.8 573.6,268.2 559.5,274.3 559.5,239.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "573.6,183.4 573.6,202.3 559.5,209 559.5,190.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "573.5,692.9 573.5,704 559.4,704.4 559.4,693.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "559.5,455.9 559.5,503 542.8,507.1 542.8,460.5 542.7,460.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "520.8,401.1 534.9,396.3 559.5,388 559.5,394.9 499.6,415.1 499.6,408.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "559.5,336.8 559.5,388 534.9,396.3 534.9,345.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "559.5,331.2 559.5,336.8 534.9,345.8 534.9,340.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "559.5,239.4 559.5,274.3 534.9,285.1 534.9,250.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "548.6,743.1 548.6,794.4 508.8,789.9 508.8,742.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "548.6,601.2 548.6,660.1 508.8,663.9 508.8,607 548.5,601  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "542.8,460.5 542.8,507.1 536.9,508.5 536.9,462 542.7,460.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "536.9,462 536.9,508.5 520.4,512.5 520.4,466.4 520.4,466.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "534.9,345.8 534.9,396.3 520.8,401.1 520.8,350.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "534.9,340.4 534.9,345.8 520.8,350.9 520.8,345.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "534.9,285.1 534.9,290.8 520.8,296.9 520.8,291.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "534.9,250.8 534.9,285.1 520.8,291.2 520.8,257.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "534.9,202.4 534.9,220.7 520.8,227.4 520.8,209.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "520.8,350.9 520.8,401.1 499.6,408.2 499.6,358.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "520.8,345.6 520.8,350.9 499.6,358.6 499.6,353.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "520.8,257.3 520.8,291.2 499.6,300.5 499.6,267.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "520.4,466.4 520.4,512.5 514.8,513.8 514.8,467.9 514.7,467.9 520.4,466.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "514.8,467.9 514.8,513.8 499.6,517.5 499.6,471.9 514.7,467.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "508.8,575.5 508.8,582.3 475.7,587.9 475.7,581.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "499.6,546.7 499.6,558.7 485.5,561.6 485.5,549.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "499.6,471.9 499.6,517.5 485.5,520.9 485.5,475.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "499.6,415.1 499.6,461.6 485.5,465.4 485.5,419.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "499.6,408.2 499.6,415.1 485.5,419.8 485.5,413  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "499.6,358.6 499.6,408.2 485.5,413 485.5,363.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "499.6,353.5 499.6,358.6 485.5,363.7 485.5,358.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "485.5,337.7 485.5,352.9 485.5,358.7 499.6,353.5 499.6,347.6 499.6,332  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "499.6,300.5 499.6,306 485.5,312.1 485.5,306.6 485.5,306.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "499.6,267.2 499.6,300.5 485.5,306.6 485.5,273.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "636.8,195.5 611.7,207.2 597.6,213.7 573.6,224.8 559.5,231.3 534.9,242.7 520.8,249.3 499.6,259.1  485.5,265.6 485.5,273.7 499.6,267.2 520.8,257.3 534.9,250.8 559.5,239.4 573.6,232.8 597.6,221.7 611.7,215.2 636.8,203.5  650.9,197 650.9,189  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "499.6,219.7 499.6,237.6 485.5,244.3 485.5,226.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M650.8,165.6L650.8,165.6l-14.1,6.7v-19.9l14-6.9l0-22.9l-14,7.1l-25.1,12.7l-14.1,7.1l-24,12.1l-14.1,7.1 l-24.6,12.4l-14.1,7.1l-21.2,10.7l-14.1,7.1v20.6l14.1-6.9v17.8l-14.1,6.7v21.3l14.1-6.5l21.2-9.9l14.1-6.5l24.6-11.4l14.1-6.5 l24-11.1l14.1-6.6l25.1-11.6l14.1-6.5L650.8,165.6z M520.8,227.4v-18.1l14.1-6.9v18.4L520.8,227.4z M559.5,209v-18.7l14.1-6.9 v18.9L559.5,209z M597.6,190.9v-19.3l14.1-6.9v19.5L597.6,190.9z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "636.8,119.2 611.1,132.9 597.4,140.3 573.1,153.2 559.4,160.6 534.5,173.9 520.8,181.2 499.6,192.5  485.5,200.1 485.5,206.1 499.6,198.9 520.8,188.2 534.9,181.1 559.5,168.7 573.6,161.6 597.6,149.4 611.7,142.3 636.8,129.6  650.7,122.6 650.9,111.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "542.8,507.1 536.9,508.5 520.4,512.5 514.8,513.8 499.6,517.5 485.5,520.9 470,524.6 465.3,525.8  448.5,529.8 444.5,530.7 431,534 431,540.4 485.5,527.4 499.6,524.1 559.5,509.8 559.5,503  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "485.5,475.7 485.5,520.9 470,524.6 470,479.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "499.6,466.3 485.5,470.1 431,484.7 431,490.2 444.5,486.7 448.5,485.6 465.3,481.1 470,479.8  485.5,475.7 499.6,471.9 514.7,467.9 520.4,466.4 536.9,462 542.7,460.4 559.5,455.9 559.5,450.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "499.6,415.1 499.6,461.6 485.5,465.4 485.5,419.8 431,438.1 431,480.1 431,484.7 485.5,470.1  499.6,466.3 559.5,450.2 559.5,445.4 559.5,394.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "448.8,425.4 462.9,420.6 485.5,413 485.5,419.8 431,438.1 431,431.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "485.5,363.7 485.5,413 462.9,420.6 462.9,420.6 462.9,371.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "485.5,358.7 485.5,363.7 462.9,371.9 462.9,367.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "439.6,782.1 475.7,786.2 475.7,790.3 431,784.1 431,781.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "475.7,741.8 475.7,786.2 439.6,782.1 439.6,741.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "439.6,741.2 431,741.1 431,736.3 475.7,736.2 475.7,741.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "439.6,670.5 475.7,667.1 475.7,673.3 431,676.7 431,671.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "475.7,612 475.7,667.1 439.6,670.5 439.6,617.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "439.6,617.4 431,618.7 431,613.1 475.7,605.7 475.7,612  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M809.7,450.2l-77.5,18.4v5.7v61.8v8.2v10.9l-14.4,2.3v-10.7v-8.1v-61v-5.6l-67.1,16l-14.1,3.3l-63.2,15v5 v52.7v7.2v9.7l-14,2.3l-0.1-0.2v-9.4v-7.1v-51.9v-4.9l-60,14.3l-14.1,3.3l-54.5,13v4.3v44.5v6.3v8.6v8.9l44.7-7.3v6.3v55.1v6.3 l-44.7,3.4v59.6l44.7-0.1v5.6v44.4v4.1l-44.7-6.2v19.2l394,81.4v-46.1v-13.3v-77.6v-12.1v-87.3v-1.9V634v-74.5v-10.9v-19.9 l-29.8,5.1v-8.6l29.8-5.3v-28.2l-15.3,3.2v-13.8l15.3-3.2v-25v-6L809.7,450.2z M625.1,555l36.5-6.4v7.8l-36.4,6.2v-7.3L625.1,555 z M636.8,530.7v-13l14.1-3v13.1L636.8,530.7z M499.6,546.7v12l-14.1,2.9v-11.9L499.6,546.7z M475.7,581.4l33.2-5.8v6.8l-33.2,5.6 V581.4z M625,744.4v58.5v8.1l-116.2-16.1v-5v-47.5v-6.3L625,736V744.4z M559.4,704.4v-10.8l14.1-0.7V704L559.4,704.4z  M508.8,670.8L508.8,670.8v-6.8v-57v-6.7l116.3-19.2v8.3v63.5v8.5l0,0.4L508.8,670.8z M795.2,747.3V822v12.5L661.6,816v-9v-62 v-9.1l133.6-0.2V747.3z M717.6,700.1v-13.7l14.5-1.1v14.3L717.6,700.1z M795.2,563.7v73.1v12L661.6,659v-0.1v-9.5v-65.6v-8.7 l133.6-22V563.7z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "470,479.8 470,524.6 465.3,525.8 465.3,481.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "465.3,481.1 465.3,525.8 448.5,529.8 448.5,529.7 448.5,485.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "462.9,420.6 462.9,420.6 448.8,425.4 448.8,377 462.9,371.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "462.9,367.1 462.9,371.9 448.8,377 448.8,372.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "462.9,316.4 462.9,321.8 448.8,327.9 448.8,322.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "448.8,377 448.8,425.4 431,431.4 431,383.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "448.8,372.4 448.8,377 431,383.5 431,379  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "731.9,232 717.9,237.6 688.6,249.5 688.6,255.7 688.6,276.2 674.2,281.6 674.2,261.5 674.2,255.3  650.9,264.7 636.8,270.5 611.7,280.6 611.7,286.7 611.7,305.2 597.6,310.6 597.6,292.4 597.6,286.3 573.6,296.1 559.5,301.8  534.9,311.7 534.9,317.7 534.9,334.2 520.8,339.6 520.8,323.4 520.8,317.4 499.6,326 485.5,331.7 462.9,340.9 462.9,346.8  462.9,361.5 448.8,366.8 448.8,352.5 448.8,346.6 431,353.8 431,359.7 431,373.5 431,379 448.8,372.4 462.9,367.1 485.5,358.7  485.5,352.9 485.5,337.7 499.6,332 499.6,347.6 499.6,353.5 520.8,345.6 534.9,340.4 559.5,331.2 559.5,324.9 559.5,307.8  573.6,302.1 573.6,319.6 573.6,326 597.6,317.1 611.7,311.9 636.8,302.6 636.8,295.8 636.8,276.6 650.9,270.9 650.9,290.4  650.9,297.3 674.2,288.6 688.6,283.3 717.9,272.4 717.9,265.1 717.9,243.9 731.5,238.3 732.2,238.3 732.2,232  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "731.5,206.1 717.9,211.9 717.9,205.5 717.8,205.3 688.6,218.1 688.6,224.6 674.2,230.8 674.2,225.1  673.9,224.5 650.9,234.6 650.9,240.8 636.8,246.9 636.8,240.7 611.7,251.6 611.7,257.7 597.6,263.8 597.6,257.8 573.6,268.2  573.6,274.1 559.5,280.2 559.5,274.3 534.9,285.1 534.9,290.8 520.8,296.9 520.8,291.2 499.6,300.5 499.6,306 485.5,312.1  485.5,306.6 462.9,316.4 462.9,321.8 448.8,327.9 448.8,322.6 431,330.3 431,335.5 431,353.8 448.8,346.6 448.8,352.5  448.8,366.8 462.9,361.5 462.9,346.8 462.9,340.9 485.5,331.7 499.6,326 520.8,317.4 520.8,323.4 520.8,339.6 534.9,334.2  534.9,317.7 534.9,311.7 559.5,301.8 573.6,296.1 597.6,286.3 597.6,292.4 597.6,310.6 611.7,305.2 611.7,286.7 611.7,280.6  636.8,270.5 650.9,264.7 674.2,255.3 674.2,261.5 674.2,281.6 688.6,276.2 688.6,255.7 688.6,249.5 717.9,237.6 731.9,232  732.2,232 732.2,206.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "448.5,529.7 448.5,529.8 444.5,530.7 444.5,486.7 448.5,485.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "444.5,486.7 444.5,530.7 431,534 431,490.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "439.6,741.2 439.6,782.1 431,781.2 431,741.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "439.6,617.4 439.6,670.5 431,671.3 431,618.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M1240.4,729.1h-77.8h-94.4v185.7h13.9h2.7h77.7h77.8h77.8h2.2h14V729.1H1240.4z M1167.7,763h67.3v21.1h-67.3 V763z M1084.9,763h72.1v21.1h-72.1V763z M1151.3,895.5h-55.2v-41.6h55.2V895.5z M1151.3,845.6h-55.2v-49.2h55.2V845.6z  M1229.1,895.5h-55.2v-41.6h55.2V895.5z M1229.1,845.6h-55.2v-49.2h55.2V845.6z M1307,895.5h-55.2v-41.6h55.2V895.5z M1307,845.6 h-55.2v-49.2h55.2V845.6z M1318.2,784.1h-72.5V763h72.5V784.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "left_window_grid"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1083.4,
  y: 376.9,
  className: "st6",
  width: 5.3,
  height: 245.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 1034.1,
  y: 392.1,
  className: "st6",
  width: 5.3,
  height: 233.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 1140.8,
  y: 365.7,
  className: "st6",
  width: 5.3,
  height: 250.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 827.5,
  y: 450.2,
  transform: "matrix(0.9807 -0.1954 0.1954 0.9807 -68.8915 207.345)",
  className: "st6",
  width: 378.3,
  height: 5.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 829.9,
  y: 508.5,
  transform: "matrix(0.9869 -0.1612 0.1612 0.9869 -69.0999 170.7002)",
  className: "st6",
  width: 374.7,
  height: 5.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 828.8,
  y: 568.5,
  transform: "matrix(0.9922 -0.125 0.125 0.9922 -63.4181 131.5052)",
  className: "st6",
  width: 374.8,
  height: 5.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 943.4,
  y: 410.9,
  className: "st6",
  width: 5.3,
  height: 493
}), /*#__PURE__*/React.createElement("rect", {
  x: 902.8,
  y: 419.6,
  className: "st6",
  width: 5.3,
  height: 480.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 865.4,
  y: 433,
  className: "st6",
  width: 5.3,
  height: 457.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 831.9,
  y: 692.4,
  transform: "matrix(0.9987 -5.178951e-02 5.178951e-02 0.9987 -34.7723 48.1031)",
  className: "st6",
  width: 157.9,
  height: 5.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 828.6,
  y: 743.6,
  transform: "matrix(1 -4.882754e-03 4.882754e-03 1 -3.6332 4.4536)",
  className: "st6",
  width: 163.4,
  height: 5.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 907.7,
  y: 718.3,
  transform: "matrix(6.759991e-02 -0.9977 0.9977 6.759991e-02 52.7901 1652.2754)",
  className: "st6",
  width: 5.3,
  height: 159.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 909.2,
  y: 766.7,
  transform: "matrix(0.1412 -0.99 0.99 0.1412 -55.52 1630.3391)",
  className: "st6",
  width: 5.3,
  height: 161
}), /*#__PURE__*/React.createElement("rect", {
  x: 1110.9,
  y: 228.2,
  className: "st6",
  width: 2.7,
  height: 42
}), /*#__PURE__*/React.createElement("rect", {
  x: 1171.1,
  y: 209.8,
  className: "st6",
  width: 2.7,
  height: 44.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1140.5,
  y: 220.1,
  className: "st6",
  width: 2.7,
  height: 42
}), /*#__PURE__*/React.createElement("rect", {
  x: 1164.3,
  y: 261.4,
  className: "st6",
  width: 4,
  height: 44.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1133.8,
  y: 271.7,
  className: "st6",
  width: 4,
  height: 42
}), /*#__PURE__*/React.createElement("rect", {
  x: 1104.1,
  y: 279.9,
  className: "st6",
  width: 4,
  height: 42
}), /*#__PURE__*/React.createElement("rect", {
  x: 1150,
  y: 314.5,
  className: "st6",
  width: 4,
  height: 47.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1108.9,
  y: 325.4,
  className: "st6",
  width: 4,
  height: 47.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1069.5,
  y: 335.3,
  className: "st6",
  width: 4,
  height: 47.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1084.9,
  y: 241,
  transform: "matrix(0.9562 -0.2927 0.2927 0.9562 -20.8374 345.4839)",
  className: "st6",
  width: 118.2,
  height: 2.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 1072.3,
  y: 296.3,
  transform: "matrix(0.9645 -0.2642 0.2642 0.9645 -38.382 311.1711)",
  className: "st6",
  width: 130.5,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 1031.2,
  y: 355.4,
  transform: "matrix(0.9699 -0.2435 0.2435 0.9699 -53.4051 282.7252)",
  className: "st6",
  width: 171.9,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 1175.1,
  y: 173.6,
  className: "st6",
  width: 2.7,
  height: 30.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 1151.5,
  y: 181.5,
  className: "st6",
  width: 2.7,
  height: 29.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 1130.4,
  y: 188.9,
  className: "st6",
  width: 2.7,
  height: 31.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 1110.6,
  y: 199.8,
  transform: "matrix(0.9447 -0.3279 0.3279 0.9447 -2.0328 390.2418)",
  className: "st6",
  width: 91.2,
  height: 2.7
})), /*#__PURE__*/React.createElement("g", {
  id: "right_window_grid"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1316.5,
  y: 376.9,
  className: "st8",
  width: 5.3,
  height: 245.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 1365.7,
  y: 392.1,
  className: "st8",
  width: 5.3,
  height: 233.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 1259,
  y: 365.7,
  className: "st8",
  width: 5.3,
  height: 250.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 1385.8,
  y: 263.8,
  transform: "matrix(0.1956 -0.9807 0.9807 0.1956 672.8242 1726.0449)",
  className: "st8",
  width: 5.3,
  height: 378.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 1385.2,
  y: 323.8,
  transform: "matrix(0.161 -0.9869 0.9869 0.161 659.9268 1798.5956)",
  className: "st8",
  width: 5.3,
  height: 374.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 1386.3,
  y: 383.7,
  transform: "matrix(0.1255 -0.9921 0.9921 0.1255 648.039 1877.4117)",
  className: "st8",
  width: 5.3,
  height: 374.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 1456.5,
  y: 410.9,
  className: "st8",
  width: 5.3,
  height: 493
}), /*#__PURE__*/React.createElement("rect", {
  x: 1497.1,
  y: 419.6,
  className: "st8",
  width: 5.3,
  height: 480.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 1534.4,
  y: 433,
  className: "st8",
  width: 5.3,
  height: 457.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 1291.6,
  y: 228.2,
  className: "st8",
  width: 2.7,
  height: 42
}), /*#__PURE__*/React.createElement("rect", {
  x: 1231.4,
  y: 209.8,
  className: "st8",
  width: 2.7,
  height: 44.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1262,
  y: 220.1,
  className: "st8",
  width: 2.7,
  height: 42
}), /*#__PURE__*/React.createElement("rect", {
  x: 1236.9,
  y: 261.4,
  className: "st8",
  width: 4,
  height: 44.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1267.4,
  y: 271.7,
  className: "st8",
  width: 4,
  height: 42
}), /*#__PURE__*/React.createElement("rect", {
  x: 1297.1,
  y: 279.9,
  className: "st8",
  width: 4,
  height: 42
}), /*#__PURE__*/React.createElement("rect", {
  x: 1251.1,
  y: 314.5,
  className: "st8",
  width: 4,
  height: 47.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1292.3,
  y: 325.4,
  className: "st8",
  width: 4,
  height: 47.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1331.6,
  y: 335.3,
  className: "st8",
  width: 4,
  height: 47.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1255.8,
  y: 185.2,
  transform: "matrix(0.2838 -0.9589 0.9589 0.2838 669.1867 1378.1383)",
  className: "st8",
  width: 2.7,
  height: 111.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 1264,
  y: 233.1,
  transform: "matrix(0.2664 -0.9639 0.9639 0.2664 640.9667 1439.3643)",
  className: "st8",
  width: 4,
  height: 131
}), /*#__PURE__*/React.createElement("rect", {
  x: 1285.7,
  y: 269.6,
  transform: "matrix(0.2391 -0.971 0.971 0.2391 633.1241 1521.99)",
  className: "st8",
  width: 4,
  height: 174.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 1224.6,
  y: 174.2,
  className: "st8",
  width: 2.7,
  height: 30.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 1248.2,
  y: 182.1,
  className: "st8",
  width: 2.7,
  height: 29.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 1269.3,
  y: 189.5,
  className: "st8",
  width: 2.7,
  height: 31.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 1244.9,
  y: 156.2,
  transform: "matrix(0.3283 -0.9446 0.9446 0.3283 646.5126 1312.6581)",
  className: "st8",
  width: 2.7,
  height: 91.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1487.8,
  y: 616.6,
  transform: "matrix(5.201660e-02 -0.9986 0.9986 5.201660e-02 718.3327 2147.8079)",
  className: "st8",
  width: 5.3,
  height: 157.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 1488.3,
  y: 665.1,
  transform: "matrix(5.102300e-03 -1 1 5.102300e-03 736.5493 2233.9854)",
  className: "st8",
  width: 5.3,
  height: 163.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 1411.3,
  y: 795.8,
  transform: "matrix(0.9977 -6.833305e-02 6.833305e-02 0.9977 -51.0737 103.7419)",
  className: "st8",
  width: 159.2,
  height: 5.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 1408.9,
  y: 845,
  transform: "matrix(0.9901 -0.1406 0.1406 0.9901 -104.3921 217.8302)",
  className: "st8",
  width: 161,
  height: 5.3
})), /*#__PURE__*/React.createElement("g", {
  id: "orange_outlines"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1373.4,354.4 1371.2,344 1577.2,298.6 1577.3,309.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1330.6,296 1328,285.6 1669.9,199.2 1670,211.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "1316.7,244.4 1314.9,239.4 1313.6,234.2 1751.5,111.7 1751.5,122.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1032.2,353.7 825,310.5 825.1,298.4 1034.4,343.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1073.6,296.1 732.4,210.9 732.2,199 1076.2,285.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "1085.8,244.5 649.5,122 650.9,111.6 1088.5,234.1 1087.3,239.3  "
})), /*#__PURE__*/React.createElement("g", {
  id: "white_lines"
}, /*#__PURE__*/React.createElement("g", {
  id: "Main_cube_lines"
}, /*#__PURE__*/React.createElement("rect", {
  x: 983,
  y: 398.7,
  className: "st7",
  width: 16,
  height: 516.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1401.8,
  y: 398.7,
  className: "st7",
  width: 16,
  height: 516.2
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "1569,656.8 1201.2,622.1 833.2,656.3 831.7,640.4 1201.2,606 1570.5,640.8  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 1193.2,
  y: 348.4,
  className: "st7",
  width: 16,
  height: 268.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 989.4,
  y: 629.9,
  className: "st7",
  width: 418.9,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M1412.5,919.6l-423.4-0.1l-169-30.2l2.6-454.4l378.5-94.6l1.9,0.5l376.2,95l1.1,452.9L1412.5,919.6z  M991.2,903.6H1411l153.4-28.3l-1-427.1l-362.2-91.5l-362.5,90.6l-2.5,428.5L991.2,903.6z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Upper_cube_lines"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "1377.2,389.1 1366.5,389.1 1366.5,348 1200.9,303.7 1038.3,347.7 1038.3,387.9 1027.7,387.9  1027.7,339.5 1200.9,292.6 1377.2,339.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "1080.1,332 1069.4,332 1069.4,282.3 1200.9,243.3 1334.3,282.6 1334.3,331.1 1323.6,331.1  1323.6,290.6 1200.9,254.4 1080.1,290.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "1320.3,282.7 1309.7,282.7 1309.7,238.2 1200.9,203.1 1092.5,238.5 1092.5,281.8 1081.9,281.8  1081.9,230.7 1200.9,191.9 1320.3,230.4  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 1195.6,
  y: 162.8,
  className: "st7",
  width: 10.7,
  height: 184.6
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "1293.6,226.8 1282.9,226.8 1282.9,199.6 1200.9,168.5 1117.1,199.6 1117.1,226.8 1106.4,226.8  1106.4,192.2 1200.9,157.1 1293.6,192.2  "
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Door_window_lines",
  className: "st7",
  points: "1407.6,835.9 1339.3,835.9 1339.3,733.6 1405.4,733.6 1405.4,723  1339.3,723 1339.3,638.4 1328.6,638.4 1328.6,723 1206.8,723 1206.6,637.5 1195.9,637.6 1196.1,723 1075.6,723 1075.6,638.4  1064.9,638.4 1064.9,723 995.4,723 995.4,733.6 1064.9,733.6 1064.9,835.9 996.4,835.9 996.4,846.5 1064.9,846.5 1064.9,912.5  1075.6,912.5 1075.6,846.5 1078,846.5 1078,835.9 1075.6,835.9 1075.6,733.6 1328.6,733.6 1328.6,835.9 1326,835.9 1326,846.5  1328.6,846.5 1328.6,912.5 1339.3,912.5 1339.3,846.5 1407.6,846.5  "
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M319.7,433.3c8.4-5.8,38.1-14.7,47.1,3c7.4,11.5-3.2,31.3-15.8,37.5c-11.6,4.8-23.1,6.9-34.2,10.1 c-12,3.5-21.9,14.5-33.3,16.3c-12.4,1.9-25-1.3-36.6-1.3c-12.4,0-23.5-6.4-35-8.5c-12.1-2.1-25.3,1.6-36.4-2.5 c-11.4-4.3-20.7-12.8-30.9-18.9c-10.4-6.3-24.5-8-33.4-16c-9-8-19.5-16.3-26.9-25.6c-7.5-9.4-9.2-23.6-15.1-34.1 c-5.9-10.5-5.6-23.6-9.8-34.8c-4.2-11.3-6.1-22.4-8.5-34.2c-2.4-11.8-2.3-22.9-2.7-34.9c-0.5-12.1-9.2-24-7.6-35.9 c1.6-11.9,1.3-25,5-36.4c3.7-11.4,19.4-17.4,25.3-28c5.8-10.4,7.7-22.5,15.7-31.8c7.6-8.9,14.9-18.4,24.6-26 c9.1-7.2,19.5-13,30.6-18.8c10.2-5.4,21.1-10.2,33-14.2c10.9-3.7,23-3.6,35.4-6.1c11.3-2.2,22.4-7.6,35-8.7 c11.2,0,22,3.3,33.1,5.3c10.9,2,21.3,4.8,32.1,8.9c10.3,3.9,21.5,6.2,31.4,12.2c9.3,5.6,15.4,15.2,24.3,22.8 c12.2,15.5,8.1,22.4-0.5,30.6c-10.4,9.9-28.6,19.9-36.9,9.7c-10.9-8.1-21.3-12-32.7-16.9c-12.3-5.4-21.4-19.4-33.9-21.4 c-13.1-2-26.5,4.1-39.2,5.6c-13,1.6-27.8-2-39.8,2.9c-11.9,4.9-18.3,20-28.8,28c-10.1,7.8-23,12.6-31.2,23 c-7.4,9.3-15,18.7-19.1,29.2c-4.3,10.7,3.6,23.9,2.3,35.3c-1.4,11.4-8.1,21.9-7.1,33.3c1.1,11.5-4.7,24.8-1.7,35.8 c3.1,11.4,13,20.8,17.7,30.9c5.1,11.1,14.1,19.1,20.3,27.8c7.6,10.7,16.6,16.5,24.6,22.1c8.9,7.3,15.5,17.1,26,21.6 c10.4,4.6,20.8,10.2,32,12.4c11.2,2.2,23-1.8,34.3-1.8c11.6,0,23.4,4.5,34.4,2.6C298.2,441.3,309.5,437.1,319.7,433.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M538,451.3c-13.9-1.8-29.3-1.1-41.5-6c-13.8-5.6-23.6-18.3-33.1-25.7c-5.1-4.3-14.4-15.8-25.4-21.5 c-11.5-6-32.2-9.4-38.4,0c-4.7,9.8,0.2,29.6,8.6,42.6c5.9,9.1,15.6,20.4,26.8,28.9c9.2,7,26.5,2.6,38.8,8.2 c10.8,4.9,21.2,9.9,34,13c11.6,2.9,23,6.6,36.1,7.5c12,0.9,24.7,8.9,37.7,7.8c12-1,26.1-0.1,38.8-3.1c11.3-3.8,19-17.2,28.5-22.7 c10.2-6,24.1-7.4,32.2-15c8.6-8,9.9-22.5,16.1-31.8c6.5-9.8,14-18.6,17.7-29.2c3.9-11,0.3-22.8,1.1-34c0.8-11.5,5.6-22.6,3.1-33.8 c-2.5-11.1-11.4-19-17.4-29c-5.7-9.6-7.4-22.3-16.3-30.2c-8.1-7.2-16.4-17.1-27.3-22.4c-9.7-4.7-21.2-9.8-33-12.7 c-12-3.3-26.4-0.4-39.7-1.3c-12.8-0.9-26,2-38.9,1.8c-13.3-0.2-27,4.6-39.4,3.6c-13.9-1.2-23.5-17-34.7-21.4 c-12.3-4.9-30-2.7-37-14.4c-10.6-16.2,7.4-31.1,16.6-41.3c8.4-8.8,15.3-17.9,26.3-23c10.7-4.9,20.8-17.3,33-19 c11.7-1.7,24.6,12.2,36.8,13c12,0.9,25.4-7.1,37-4.1c11.9,3.1,22.7,10.3,33.4,15.2c11.4,5.3,21.1,12.9,30,20 c12,12,27.8,8,37.3-1.7c9.5-9.6,17.9-30.8,5.4-42.5c-8.6-7.2-23.2-8-33.4-13.9c-9.8-5.6-22.5-4.8-33.4-9.1 c-10.6-4.2-19.8-11.5-31-14.3c-11.2-2.8-22.7-0.7-34.1-1.9c-11.5-1.3-22.3-5.1-33.7-4.7c-11.6,0.4-21.6,6.6-32.7,8.9 c-11.4,2.4-26.2-6.8-36.6-2.2c-10.6,4.6-17.1,17.1-26.2,24.1c-8.9,7-19,13.1-25.9,22.6c-6.5,8.9-15.5,18-19.8,29.3 c-4.2,12.5,5.7,26.1,7.5,38.7c1.8,12.7-5.9,29.6,1,40.5c6.9,10.7,23.8,13.4,34.8,20.3c10,6.8,20.5,11.4,33,14.9 c11.6,3.3,22.2,15.9,34.9,17.4c12.2,1.5,25.8-8.5,38.4-7.9c12.6,0.7,25,5.2,37.2,5.9c13.1,0.7,25,5.9,36.6,7.6 c13.6,2.1,26.2,1.4,36.2,6.5c11.7,5.9,28.4,11,32.8,23.4c3.5,9.7-8.2,23.8-10.6,39c-1.9,12.2-6.9,19.9-12.5,29.1 c-6.1,9.9-13,14.9-22.3,21.5c-9.1,6.5-13.1,23.2-24.3,26.7c-10.7,3.4-23.7-0.6-35.2,0.3C560.8,451.1,549.3,452.6,538,451.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M386.1,910c-12.1,0-24.2-1.9-36.3-2c-12.1,0-24.2,10.9-36.3,10.8c-12.1,0-24.2-5.1-36.3-5.1s-24.2-4.1-36.3-4.1 c-12.1,0-24.2,7.6-36.3,7.6s-24.2,2.6-36.3,2.6c-12.1,0-24.2,1.2-36.3,1.2c-12.1,0-24.2-2-36.3-2c-15,0-30.2-17-30.9-31.5 C64,873,81.6,863,95.6,863c10.5,0,21.1-9.9,31.6-9.9s21.1,7.8,31.6,7.8c10.5,0,21.1-4.8,31.6-4.8s24.1,7.1,34.7,7.1 c-0.1-12.8,1.8-28.1,1.6-40.8c-0.1-12.8-8.1-25.4-8.2-38.2c-0.1-12.8,5.8-25.6,5.7-38.3c-0.1-12.8,0.9-25.5,0.7-38.3 c-0.1-12.8-11.5-25.4-11.6-38.1s6.7-25.6,6.6-38.3s3-30.5,2.9-43.3c-11.1,4.7-23.5,20.5-34.8,24.8c-11.3,4.3-25.2,1.6-36.6,5.4 c-11.5,3.8-24.7,1.2-36.3,4.4c-14.4,4.1-31.4,3.1-35.8-10.6c-4.5-13.8,11.9-24,25.3-27.8c12.1-3.4,25.3-10.6,37.6-14.8 c21-7.2,38.8-11.3,38.2-11c11.1-3.4,20.3-13.7,30.2-18.4c12.1-5.7,22.2-13.5,30.8-15.4c15.7-3.3,26.7,12.5,26.8,27.9 c0.1,11.4,4,22.8,4.1,34.3c0.1,11.4-1.3,22.9-1.2,34.3c0.1,11.4,8.3,22.8,8.5,34.2c0.1,11.4-1.2,22.9-1.1,34.3 c0.1,11.4-11.5,23-11.4,34.4s4.9,22.8,5,34.2c0.1,11.4-1.8,22.9-1.7,34.3c0.1,11.4,11.9,22.7,12,34.2 c0.1,11.4-5.4,21.1-5.3,32.5c12.3,0,22.9,0.5,35.2,0.5c12.3,0,24.6-3.5,36.9-3.5c12.3,0,24.6-2.5,36.9-2.5 c15,0,31,19.4,31.6,33.9C418.4,901.8,400.1,910,386.1,910z"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M721.6,580c-7.5,10.8-18.8,20.1-26.3,30.9c-7.5,10.8-6.1,27.7-13.6,38.5c-7.5,10.8-18.5,19.2-25.9,30 c-7.5,10.8-17.4,21.9-24.8,32.7c7.7-0.1,14.8-4,20.1-10.1c6.7-16.9,21.4-13.5,31-13.6c11.8-0.1,20.8,2.7,23.6,16.4 c2.1,10.4-1.4,19.9-11.9,31.6c-6.8,7.5-16.8,10.4-31,16.5c-10.8,4.3-18.9,19-29.9,18.9c-11-0.1-19.9-3.1-30.8-5.9 c-7,10.1-18.5,13.4-25.5,23.5c-7,10.1-5.8,25.8-12.8,35.9c-7,10.1-18.6,17-25.5,27.1s-13.2,20.7-20.1,30.8 c-7,10.1-18.8,16.8-25.7,26.9c-8.5,12.3-19.6,18.6-33.2,11.4c-12.1-6.4-15.7-23.3-7.7-34.8c6.5-9.4,9.1-21.4,15.5-30.8 s18.4-15,24.8-24.4c6.5-9.4,12.2-19.3,18.6-28.7c6.5-9.4,7.6-22.5,14-31.9s21.3-20.8,27.8-30.2c-15.2-3.7-38.3-2.7-51.3,8.2 c-4.5,16.7-20.1,15.3-33.1,11.7c-12.9-3.6-24.1-10.2-19.4-26.8c4.3-13.4,13.7-20,23.2-27.2c9.9-7.5,20.2-9.1,33.1-11.1 c12.2-1.9,23.8-6,36.4-4.3c13,1.8,24.6-1.3,35.6,3.1c6.6-9.5,12.4-16.1,18.9-25.6c6.6-9.5,15.7-17.2,22.3-26.7 c6.6-9.5,18-15.6,24.6-25.1s5.3-15.7,11.9-25.2c-17.5-5.5-16.1-8.8-34.4-8.8c-18.3,0-18.3,8.3-36.6,8.3c-18.3,0-18.3-5-36.6-5 c-18.3,0-18.3-1.7-36.6-1.7c-18.3,0-18.3,2.3-36.6,2.3c-18.3,0-18.3-4.8-36.6-4.8c-18.3,0-18.3,3.4-36.6,3.4 c-15,0-23.8-13.2-24.4-27.6c-0.6-14.4,10.4-33.9,24.4-33.9c18.8,0,18.8,5.9,37.5,5.9c18.8,0,18.8,2.7,37.5,2.7 c18.8,0,18.8-1.3,37.5-1.3c18.8,0,18.8,3.4,37.5,3.4c18.8,0,18.8-0.4,37.5-0.4c18.8,0,18.8,2.7,37.5,2.7c18.8,0,18.8-12,37.5-12 c18.8,0,18.5,5.3,37.2,3.3c15.3-5.7,32.8,4.8,38.8,17.1C745,557.8,738.3,572.7,721.6,580z"
})))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3",
  className: "st9"
}, /*#__PURE__*/React.createElement("g", {
  className: "st10"
}, /*#__PURE__*/React.createElement("path", {
  d: "M319.3,432.7c8.4-5.8,34.5-11.9,43.6,5.8c7.4,11.5,3.7,35.8-8.9,42c-11.6,4.8-24.5,6-35.6,9.3c-12,3.5-24.4,3.9-35.8,5.6 c-12.4,1.9-24.3,9.2-35.9,9.2c-12.4,0-24.7-5.3-36.2-7.3c-12.1-2.1-25.2-2.4-36.2-6.5c-11.4-4.3-17.2-19.8-27.3-25.9 c-10.4-6.3-23.2-8.1-32.2-16.1c-9-8-12.8-20.3-20.3-29.7c-7.5-9.4-25.3-12.2-31.1-22.6c-5.9-10.5-2-26-6.2-37.3 c-4.2-11.3-9-22.2-11.4-33.9c-2.4-11.8-10.5-23.4-10.9-35.4c-0.5-12.1,1.8-24.8,3.4-36.7c1.6-11.9,2.2-25.1,5.8-36.6 c3.7-11.4,18.9-18,24.8-28.6c5.8-10.4,8.6-22.3,16.6-31.6c7.6-8.9,14.3-19.5,24-27.2c9.1-7.2,20.6-11.9,31.7-17.7 c10.2-5.4,21.3-9.9,33.2-13.9c10.9-3.7,22.2-7.9,34.6-10.3c11.3-2.2,23.5,0.3,36-0.7c11.2,0,21.8,0.1,33,2.2 c10.9,2,20.9,5.9,31.6,10c10.3,3.9,19.1,9.7,29,15.7c9.3,5.6,19.2,9.7,28,17.2c12.2,15.5,5.6,21.5-2.9,29.7 c-10.4,9.9-20,14.3-28.3,4c-10.9-8.1-27.4-6.7-38.8-11.7c-12.3-5.4-22.7-14.8-35.2-16.7c-13.1-2-27.2-7.7-39.9-6.1 c-13,1.6-26.8,6.8-38.8,11.8c-11.9,4.9-17.8,20.9-28.2,28.9c-10.1,7.8-29.2,7.4-37.5,17.8c-7.4,9.3-7.5,24-11.6,34.5 c-4.3,10.7-2.9,22.7-4.2,34.1c-1.4,11.4,1.5,22,2.6,33.5c1.1,11.5-5.2,24.1-2.2,35.1c3.1,11.4,13.8,19.6,18.4,29.7 c5.1,11.1,5,24.3,11.2,33c7.6,10.7,12.4,24.5,20.4,30.1c8.9,7.3,23.8,6.3,34.2,10.8c10.4,4.6,19.9,14.7,31.2,16.9 c11.2,2.2,23.9,1,35.2,1c11.6,0,23.1-4.9,34.1-6.7C297.9,439.4,309.2,436.4,319.3,432.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st10"
}, /*#__PURE__*/React.createElement("path", {
  d: "M537.2,457.6c-13.9-1.8-23.6-19.6-35.8-24.4c-13.8-5.6-30.2-4-39.7-11.3c-5.1-4.3-13.9-15.5-24.9-21.2 c-11.5-6-30.3-11.6-36.5-2.1c-4.7,9.8,2.8,27.2,11.2,40.2c5.9,9.1,19.9,12.5,31.2,21c9.2,7,15.6,20,27.8,25.6 c10.8,4.9,23.7,6,36.5,9.2c11.6,2.9,23.9,2.9,36.9,3.8c12,0.9,24.7,9.8,37.7,8.6c12-1,24-7.9,36.7-10.9 c11.3-3.8,24.1-4.7,33.6-10.3c10.2-6,18.2-15.7,26.4-23.3c8.6-8,11.1-20.6,17.2-29.9c6.5-9.8,19.5-16.1,23.2-26.7 c3.9-11,6.7-23.4,7.5-34.7c0.8-11.5-2.6-23.9-5.1-35c-2.5-11.1-10.9-20.1-16.9-30.1c-5.7-9.6-12.5-17.8-21.4-25.7 c-8.1-7.2-14.4-18.7-25.3-24.1c-9.7-4.7-23.2-0.8-35.1-3.7c-12-3.3-24.3-2.3-37.7-3.2c-12.8-0.9-25.5-2.7-38.4-2.9 c-13.3-0.2-26.5-4.2-38.9-5.3c-13.9-1.2-25.1-8.9-36.2-13.3c-12.3-4.9-27.2-6.6-34.2-18.3c-10.6-16.2,1.6-33.9,10.8-44 c8.4-8.8,21.6-9.3,32.7-14.3c10.7-4.9,18.9-20,31.1-21.7c11.7-1.7,24.8,3.1,37,4c12,0.9,25.4-2,37,1c11.9,3.1,24.6,7.1,35.2,12.1 c11.4,5.3,14.3,22.8,23.2,29.9c12,12,31.8,2.6,41.2-7c9.5-9.6,16.8-28.5,4.3-40.2c-8.6-7.2-24.3-5-34.6-10.9 c-9.8-5.6-18.3-13.3-29.2-17.6c-10.6-4.2-19-16.8-30.3-19.6c-11.2-2.8-24.2,2-35.6,0.7c-11.5-1.3-23.2-4-34.6-3.6 c-11.6,0.4-22,9.1-33.1,11.4c-11.4,2.4-23.8,0.2-34.2,4.7c-10.6,4.6-18.3,13.7-27.4,20.7c-8.9,7-12.5,17.4-19.4,26.9 c-6.5,8.9-13.7,16-18,27.3c-4.2,12.5-1.8,22.7,0,35.3c1.8,12.7,3.7,22.8,10.6,33.7c6.9,10.7,7.8,28.1,18.8,35.1 c10,6.8,26.8-0.8,39.3,2.8c11.6,3.3,20.9,20.5,33.7,22c12.2,1.5,25.9-8.8,38.4-8.2c12.6,0.7,24.6,13.3,36.7,14 c13.1,0.7,26.1-6.2,37.7-4.5c13.6,2.1,29.4-2,39.4,3c11.7,5.9,16.2,21.6,20.6,34c3.5,9.7,4,21.5,1.7,36.6 c-1.9,12.2,0.6,26.3-5.1,35.5c-6.1,9.9-20.3,13.7-29.6,20.3c-9.1,6.5-17.7,15.8-28.9,19.3c-10.7,3.4-22.5,8.9-34.1,9.8 C561.4,458.9,548.5,459,537.2,457.6z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st10"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M386.1,906.9c-12.1,0-24.2,2.4-36.3,2.4c-12.1,0-24.2,6.2-36.3,6.2c-12.1,0-24.2-6.1-36.3-6.1c-12.1,0-24.2,6-36.3,6 c-12.1,0-24.2,2.1-36.3,2.1c-12.1,0-24.2,0.4-36.3,0.4c-12.1,0-24.2-4.6-36.3-4.7c-12.1,0-24.2,0.5-36.3,0.5 c-15,0-24-12-24.7-26.5C70.3,872.7,81.6,853,95.6,853c10.5,0,21.1-0.1,31.6-0.1c10.5,0,21.1,7.1,31.6,7.1c10.5,0,21.1,3,31.6,3 s19.2-3.9,29.7-3.9c-0.1-12.8,8.2-24,8-36.8c-0.1-12.8-3.8-25.5-4-38.2c-0.1-12.8-0.1-25.5-0.2-38.3 c-0.1-12.8-10.2-25.4-10.3-38.2c-0.1-12.8,12.6-25.6,12.4-38.4c-0.1-12.8-10.6-25.4-10.8-38.2c-0.1-12.8,6.7-29.2,6.5-41.9 c-11.1,4.7-22.7,18.6-34,22.8c-11.3,4.3-25.3,1.2-36.7,5c-11.5,3.8-21.8,11.3-33.4,14.6c-14.4,4.1-35.5-5.7-39.9-19.4 c-4.5-13.8,11.4-31.4,24.9-35.2c12.1-3.4,25.4-9.1,37.7-13.4c21-7.2,37.9-15.1,37.3-14.9c11.1-3.4,24.3-1.9,34.2-6.5 c12.1-5.7,22.7-7.8,31.4-9.8c15.7-3.3,33,4.3,33.1,19.6c0.1,11.4-11,23-10.9,34.4c0.1,11.4,4.3,22.8,4.4,34.2 c0.1,11.4,5.7,22.8,5.8,34.2c0.1,11.4-6.2,22.9-6.1,34.4c0.1,11.4,9.3,22.8,9.4,34.2s2.2,22.8,2.3,34.3 c0.1,11.4-6.3,22.9-6.1,34.4s-2.9,22.9-2.8,34.3c0.1,11.4,3.3,22.5,3.5,33.9c12.3,0,24.3,7.8,36.5,7.9 c12.3,0,24.6-12.7,36.9-12.7s24.6,3.5,36.8,3.5c15,0,20.1,14.2,20.8,28.7C407.5,902.3,400.1,906.9,386.1,906.9z"
})))), /*#__PURE__*/React.createElement("g", {
  className: "st10"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M727.1,587.4c-7.5,10.8-16.6,18-24.1,28.8s-22.5,16.4-30,27.2c-7.5,10.8-7.1,27.1-14.5,37.9 c-7.5,10.8-17.7,20-25.2,30.9c7.7-0.1,14.3-3.1,19.6-9.1c6.7-16.9,19.7-19.6,29.2-19.7c11.8-0.1,20.9,7.9,23.7,21.6 c2.1,10.4,7.1,27.7-3.4,39.4c-6.8,7.5-24.6,4.7-38.8,10.8c-10.8,4.3-19.7,7.3-30.6,7.1c-11-0.1-19.1,8.8-30,6.1 c-7,10.1-21,10-28,20.1c-7,10.1-4.3,26.8-11.3,36.9c-7,10.1-23.4,13.7-30.3,23.8s-9.3,23.3-16.3,33.4s-9.2,23.5-16.1,33.6 c-8.5,12.3-28.9,14-42.5,6.8c-12.1-6.4-12.4-22.8-4.4-34.3c6.5-9.4,5.3-24.1,11.8-33.4c6.5-9.4,9.5-21.1,16-30.5 c6.5-9.4,16.3-16.4,22.8-25.8c6.5-9.4,14.6-17.6,21.1-27c6.5-9.4,10.8-15.5,17.3-24.9c-15.2-3.7-25.5-6.7-38.5,4.3 c-4.5,16.7-26,21.6-38.9,18c-12.9-3.6-19.3-17.9-14.6-34.6c4.3-13.4,4.4-29.9,13.9-37.1c9.9-7.5,26.8-1.8,39.7-3.9 c12.2-1.9,24-3.3,36.6-1.6c13,1.8,24-4.4,35,0c6.6-9.5,11.7-14.6,18.3-24.2c6.6-9.5,20-14.3,26.5-23.8 c6.6-9.5,5.1-24.6,11.6-34.1c6.6-9.5,19.7-22.1,26.2-31.6c-17.5-5.5-20.3,5.1-38.6,5.1c-18.3,0-18.3,2.5-36.6,2.5 c-18.3,0-18.3,0.6-36.6,0.6c-18.3,0-18.3-0.8-36.6-0.8c-18.3,0-18.3-1.3-36.6-1.3c-18.3,0-18.3-2.1-36.6-2.1 c-18.3,0-18.3,4.3-36.6,4.3c-15,0-31.1-14.2-31.8-28.7c-0.6-14.4,17.8-24,31.8-24c18.8,0,18.8-4.5,37.5-4.5 c18.8,0,18.8-0.1,37.5-0.1c18.8,0,18.8-2.3,37.5-2.3c18.8,0,18.8,7,37.5,7c18.8,0,18.8-3.1,37.5-3.1c18.8,0,18.8-0.3,37.5-0.3 c18.8,0,18.8,4.3,37.5,4.3c18.8,0,18.6-4,37.3-6c15.3-5.7,28.7,6,34.8,18.3C741.1,559.7,743.8,580.1,727.1,587.4z"
})))));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_4",
  className: "st9"
}, /*#__PURE__*/React.createElement("g", {
  className: "st10"
}, /*#__PURE__*/React.createElement("path", {
  d: "M320.8,435.5c8.4-5.8,34.5-15.5,43.6,2.2c7.4,11.5-2.9,25.4-15.5,31.6c-11.6,4.8-19.3,17.6-30.3,20.8 c-12,3.5-25.2-1.4-36.6,0.3c-12.4,1.9-23.5,7.2-35.1,7.2c-12.4,0-23.6-4.8-35.1-6.8c-12.1-2.1-22.2-7-33.2-11.1 c-11.4-4.3-23.5-5.1-33.6-11.3c-10.4-6.3-24.4-8-33.3-15.9c-9-8-16.1-18.7-23.6-28.1c-7.5-9.4-11.6-21.4-17.4-31.9 c-5.9-10.5-5-23.5-9.2-34.8c-4.2-11.3-21.8-18.9-24.2-30.7c-2.4-11.8,5.6-25.4,5.2-37.4c-0.5-12.1-8.7-24.9-7.1-36.8 c1.6-11.9,9.4-23.3,13.1-34.8c3.7-11.4,10.1-21.9,16-32.5c5.8-10.4,10.8-21.8,18.7-31.1c7.6-8.9,19.7-13.6,29.5-21.2 c9.1-7.2,17.2-16.6,28.2-22.4c10.2-5.4,22.4-7.1,34.3-11.1c10.9-3.7,20.3-16.5,32.6-18.9c11.3-2.2,24.6,2.1,37.1,1.1 c11.2,0,22.2,3.8,33.4,5.9c10.9,2,22,3.7,32.7,7.8c10.3,3.9,18.5,11.9,28.4,17.9c9.3,5.6,18,11.3,26.8,18.8 c12.2,15.5,7.2,22.2-1.4,30.4c-10.4,9.9-28.9,21.3-37.2,11.1c-10.9-8.1-18.9-16.5-30.3-21.4c-12.3-5.4-24.2-8.2-36.6-10.1 c-13.1-2-25-1.2-37.7,0.3c-13,1.6-27.4-2.8-39.4,2.2c-11.9,4.9-24.3,11.5-34.8,19.4c-10.1,7.8-12.9,23.3-21.1,33.7 c-7.4,9.3-9.6,19-13.7,29.5c-4.3,10.7-19.1,18.4-20.5,29.8c-1.4,11.4-3.4,24.1-2.4,35.6c1.1,11.5,14.6,21,17.6,31.9 c3.1,11.4,1.9,23.8,6.6,33.9c5.1,11.1,7.4,23.8,13.6,32.5c7.6,10.7,21.6,13.8,29.6,19.4c8.9,7.3,19.2,10.2,29.6,14.8 c10.4,4.6,20.3,6.1,31.6,8.3c11.2,2.2,21.3,5.2,32.6,5.2c11.6,0,22.3,0,33.3-1.9C297.1,434.7,310.6,439.3,320.8,435.5z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st10"
}, /*#__PURE__*/React.createElement("path", {
  d: "M538.2,449.7c-13.9-1.8-24.3-12.6-36.4-17.5c-13.8-5.6-26.8-7.9-36.3-15.2c-5.1-4.3-17-12.1-28-17.8 c-11.5-6-19.3-3.5-25.6,5.9c-4.7,9.8-14.1,23.9-5.7,36.9c5.9,9.1,22,13.2,33.3,21.8c9.2,7,20.5,11.8,32.8,17.4 c10.8,4.9,22.8,6.6,35.6,9.7c11.6,2.9,23.3,3.2,36.3,4.2c12,0.9,23.3-0.7,36.3-1.8c12-1,24.9,5,37.7,2c11.3-3.8,23-6.2,32.5-11.8 c10.2-6,15.6-17.7,23.7-25.3c8.6-8,20.9-12.5,27-21.8c6.5-9.8,17.4-18.7,21.1-29.3c3.9-11-1.2-25-0.4-36.3 c0.8-11.5-8.4-21.3-10.9-32.4c-2.5-11.1,0.2-23.1-5.7-33.1c-5.7-9.6-9-22.4-17.9-30.3c-8.1-7.2-23.8-3.9-34.7-9.3 c-9.7-4.7-15.5-22.2-27.4-25.1c-12-3.3-27.5,10.4-40.8,9.5c-12.8-0.9-25.4-3.2-38.4-3.4c-13.3-0.2-25.8-13.4-38.1-14.4 c-13.9-1.2-25.2-1.9-36.3-6.3c-12.3-4.9-25.3-6.5-32.3-18.2c-10.6-16.2,4.3-27.3,13.5-37.5c8.4-8.8,11.8-24.1,22.8-29.2 c10.7-4.9,24-6.5,36.2-8.3c11.7-1.7,24,3.3,36.2,4.2c12,0.9,24,0.7,35.7,3.7c11.9,3.1,26.4,0.4,37,5.4 c11.4,5.3,19.7,17.1,28.6,24.2c12,12,25.6,7.9,35.1-1.7c9.5-9.6,9.9-19.4-2.6-31.1c-8.6-7.2-12.2-21.4-22.4-27.3 c-9.8-5.6-20.7-10.7-31.6-15c-10.6-4.2-23.5-2-34.7-4.8c-11.2-2.8-21.3-12.7-32.7-13.9c-11.5-1.3-23.7,2.5-35.1,2.9 c-11.6,0.4-23.5,0.7-34.6,3.1c-11.4,2.4-19.1,14.6-29.5,19.2c-10.6,4.6-22.8,4.7-31.8,11.8c-8.9,7-18.5,13.7-25.4,23.2 c-6.5,8.9-14.6,18.4-18.9,29.7c-4.2,12.5-2.7,26.9-0.9,39.5c1.8,12.7,2,28.4,9,39.2c6.9,10.7,16.9,23.6,28,30.6 c10,6.8,24,12.2,36.5,15.8c11.6,3.3,26.9-8.3,39.6-6.7c12.2,1.5,24.5,0.8,37,1.5c12.6,0.7,24.9,7.2,37.1,7.9 c13.1,0.7,26.1,0,37.7,1.8c13.6,2.1,27.1,5.1,37.1,10.1c11.7,5.9,22.8,16.3,27.3,28.7c3.5,9.7,3.6,23.9,1.3,39.1 c-1.9,12.2-10.9,21.4-16.5,30.5c-6.1,9.9-11,21.2-20.3,27.8c-9.1,6.5-22.6,4.3-33.7,7.9c-10.7,3.4-20.5,9.6-32.1,10.5 C560.9,451.4,549.5,451.1,538.2,449.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st10"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M386.1,919c-12.1,0-24.2-1.2-36.3-1.2c-12.1,0-24.2-2.4-36.3-2.4c-12.1,0-24.2-8.5-36.3-8.5c-12.1,0-24.2,6.5-36.3,6.5 c-12.1,0-24.2-6.2-36.3-6.2c-12.1,0-24.2,0.3-36.3,0.2c-12.1,0-24.2,3.3-36.3,3.2c-12.1,0-24.2,5.7-36.3,5.7 c-15,0-23.6-14.6-24.3-29.1c-0.6-14.4,10.3-27.3,24.3-27.3c10.5,0,21.1,5.2,31.6,5.2c10.5,0,21.1-10,31.6-10 c10.5,0,21.1,2.2,31.6,2.2c10.5,0,18.6,1.4,29.2,1.4c-0.1-12.8,8.8-23.6,8.7-36.4c-0.1-12.8-3.5-25.5-3.7-38.2 c-0.1-12.8-8.8-25.4-8.9-38.2c-0.1-12.8,10.7-25.6,10.6-38.4c-0.1-12.8-4.2-25.5-4.3-38.2s2.7-25.5,2.6-38.3s-1.6-30.5-1.7-43.2 c-11.1,4.7-25,16.6-36.3,20.8c-11.3,4.3-24.2,3.9-35.7,7.7c-11.5,3.8-23.9,3.7-35.5,7c-14.4,4.1-19.8-1.7-24.3-15.4 c-4.5-13.8-0.2-21,13.3-24.8c12.1-3.4,25-11.3,37.3-15.6c21-7.2,35.4-22.9,34.8-22.7c11.1-3.4,22.4-4.4,32.3-9.1 c12.1-5.7,25.3-3.5,34-5.4c15.7-3.3,25.4,6.5,25.5,21.8c0.1,11.4,9.1,22.8,9.2,34.2c0.1,11.4-6.2,22.9-6.1,34.4 c0.1,11.4,1.1,22.8,1.2,34.3c0.1,11.4,0.3,22.9,0.5,34.3c0.1,11.4,7.7,22.8,7.8,34.2c0.1,11.4,1,22.8,1.1,34.3 s-1.6,22.9-1.5,34.3s-10.5,23-10.4,34.4c0.1,11.4,5.9,22.2,6.1,33.6c12.3,0,24,3.2,36.3,3.2c12.3,0,24.6,4.4,36.9,4.4 c12.3,0,24.6-2.7,36.9-2.7c15,0,27.7,7.9,28.4,22.4C415.1,902,400.1,919,386.1,919z"
})))), /*#__PURE__*/React.createElement("g", {
  className: "st10"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M724.7,584.2c-7.5,10.8-20.4,16.9-27.8,27.7c-7.5,10.8-11.5,24-19,34.8c-7.5,10.8-18.3,19.3-25.7,30.2 s-13.4,24.4-20.9,35.2c7.7-0.1,12.4-5.2,17.7-11.2c6.7-16.9,23.6-16.5,33.1-16.5c11.8-0.1,18.3,7.3,21.1,21 c2.1,10.4,0.7,19-9.8,30.7c-6.8,7.5-15.2,13.6-29.4,19.7c-10.8,4.3-20.1,17.7-31.1,17.6c-11-0.1-22.4-11-33.4-13.7 c-7,10.1-16.3,19.3-23.3,29.4c-7,10.1-8.1,24.2-15,34.3s-21.7,14.8-28.6,24.9c-7,10.1-9.6,23.1-16.6,33.2s-17.3,17.8-24.3,27.9 c-8.5,12.3-21.2,23.6-34.8,16.4c-12.1-6.4-16.7-30.1-8.7-41.6c6.5-9.4,20.1-13.8,26.6-23.2s10.3-20.6,16.7-30 c6.5-9.4,11-20.1,17.5-29.5c6.5-9.4,9.8-21,16.2-30.4c6.5-9.4,19.7-20.6,26.1-30c-15.2-3.7-45.7-8.7-58.6,2.3 c-4.5,16.7-11.6,20-24.5,16.4c-12.9-3.6-22.9-9.1-18.3-25.8c4.3-13.4,9.8-23.8,19.3-31c9.9-7.5,22-10.3,34.9-12.3 c12.2-1.9,25.5-8.2,38.1-6.5c13,1.8,25.4,11.4,36.4,15.8c6.6-9.5,8.8-23.3,15.3-32.8c6.6-9.5,22.4-12.6,29-22.1 c6.6-9.5,12.1-19.7,18.6-29.2c6.6-9.5,9.3-23.6,15.8-33.1c-17.5-5.5-18.8-4.1-37.1-4.1c-18.3,0-18.3,12.8-36.6,12.8 c-18.3,0-18.3-4.5-36.6-4.5c-18.3,0-18.3-0.5-36.6-0.5c-18.3,0-18.3,0.3-36.6,0.3c-18.3,0-18.3-6.8-36.6-6.8 c-18.3,0-18.3,4-36.6,4c-15,0-24.5-11.8-25.2-26.3c-0.6-14.4,11.2-24.8,25.2-24.8c18.8,0,18.8,1.2,37.5,1.2 c18.8,0,18.8-10.2,37.5-10.2c18.8,0,18.8,2,37.5,2c18.8,0,18.8,8.5,37.5,8.5c18.8,0,18.8,4,37.5,4c18.8,0,18.8-11.4,37.5-11.4 c18.8,0,18.8,7.7,37.5,7.7c18.8,0,19.6,5.1,38.2,3.1c15.3-5.7,34.6-6.4,40.7,5.9C748,556.3,741.5,577,724.7,584.2z"
})))));

function SvgCitLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 1000",
    style: {
      enableBackground: "new 0 0 2000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitLogo1);
export default __webpack_public_path__ + "static/media/CIT_Logo_1.8f7df26b.svg";
export { ForwardRef as ReactComponent };